import React from 'react';
import { MakerContainer } from './Maker';
import { updateActivity, setNoErrors, catchErrors } from '../middleware';

// Redux components
import { combineReducers, applyMiddleware, createStore } from 'redux';
import { Provider } from 'react-redux';
import middleware from 'redux-thunk';
import reducer from '../reducer';

const ProjectNewApp = (props) => {
  const combinedProps = reducer(undefined, {
    type: 'SET_STATE',
    state: props,
  });
  const store = applyMiddleware(middleware, catchErrors)(createStore)(reducer, combinedProps);

  return (
    <Provider store={store}>
      <MakerContainer />
    </Provider>
  );
};

export default ProjectNewApp;
